import { Button, Col, ConfigProvider, Divider, message, Popover, Row, } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import zhCN from 'antd/lib/locale/zh_CN';
import axios from 'axios';
import Qs from 'qs';

import { UserOutlined, LogoutOutlined,DownOutlined} from '@ant-design/icons';

import Cookies from 'js-cookie';
import userStyles from './user.module.less';

import './user-center.css';
import localStorage from 'localStorage';
import {sendHttpPostRequest} from "../../../api/http-request";
import {delCookie, getCookie} from "../login-register/login-register";
import { BACKEND_API_URL } from '../../../constants/constants';
import * as constants from "../../../constants/constants";
export interface Props {}
let globalUserLogin = false;

/**
 * UserInfo
 * 用户信息
 */
export const UserInfo: React.FC<Props> = (props) => {
  const [userLogin, setUserLogin] = useState(false); // 登录 false / true
  const [userId, setUserId] = useState(0); // 用户id
  const [userName, setUserName] = useState(''); // 用户昵称
  const [userAvatar, setUserAvatar] = useState('/static/image/avatar/default_avatar.png'); // 用户头像
  
  const [collegeId, setCollegeId] = useState(0) // 院校ID
  const [collegeName, setCollegeName] = useState('') // 院校名称
  const [collegeInfo, setCollegeInfo] = useState(null as any) //查询当前用户的机构信息,is_college_teacher weitrue表示是教师，

  const [isManager, setIsManager] = useState(0) // 是否是院校管理员

  useEffect(() => {
    !getUserInfoFromLocal() ? checkLogin() : "local";
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          if (response?.college_id !== 0) {
            //已加入机构
            let _collegeId = response.college_info.college_id
            setCollegeId(_collegeId)
            setCollegeInfo(response.college_info)
            setCollegeName(response.college_info.college_name)
            setIsManager(response.college_info.is_manager)
      
          } else {
            //未加入机构
            setCollegeId(0)
          }
        } 
      }
    )
  }, [])

  // 从本地获取用户信息
  const getUserInfoFromLocal = () => {
    try {
      const user_info = JSON.parse(localStorage.getItem("user_info"));
      if (!user_info) {
        return false;
      } else {
        setUserLogin(true);
        setUserId(user_info.login_user_id);
        setUserName(user_info.login_user_name);
        setUserAvatar(user_info.login_user_avatar);
        console.log("已登录");
        globalUserLogin = true;
        return true;
      }
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  /**
   * 校验用户是否登录
   */
  const checkLogin = () => {
    const sessionid = Cookies.get("sessionid");
    if (sessionid) {
      const _data = Qs.stringify({
        sessionid: sessionid
      })
      const _headers = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}};
      axios
        .post(
          constants.BACKEND_API_URL + 'account/api/check_login/',
          _data,
          _headers
        )
        .then((response) => response.data)
        .then((data) => {
          setUserLogin(true);
          setUserId(data.login_user_id);
          setUserName(data.login_user_name);
          setUserAvatar(data.login_user_avatar);
          globalUserLogin = true;
          // localStorage.setItem("user_info", JSON.stringify(data));
          console.log("登录成功");
          // console.log(data);
        })
        .catch((e) => {
          console.error(':)校验失败了', e);
        })
    } else {
      console.log("用户未登录");
    }
  }

  const content = (<div style={{width:250}}>
      <div className={userStyles.useCenterContentActionDiv} style={{textAlign:"center"}}  > 
       {userName}
     </div>
     <div style={{textAlign:"center",marginBottom:10}} > 
      <img  style={{height:36,width:36,borderRadius:18}} src={BACKEND_API_URL + userAvatar} />
     </div>

    <div className={userStyles.useCenterContentActionDiv} onClick={handleGoUserCenter.bind(userId)} > 
      <Row  align="middle" gutter={[0,0]} style={{paddingLeft:20,paddingRight:20,height:36,margin:0}} >
        <Col style={{margin:0}}  >
          <UserOutlined style={{marginRight:10}}/>
        </Col>
        <Col style={{margin:0}}> 个人中心 </Col>
       </Row>
     </div>

     <div className={userStyles.useCenterContentActionDiv} onClick={handleGoLogout} > 
      <Row align="middle" gutter={[0,0]} style={{paddingLeft:20,paddingRight:20,height:36,margin:0}}  >
        <Col style={{margin:0}} >
          <LogoutOutlined style={{marginRight:10}}/> 
        </Col  >
        <Col style={{margin:0}} > 退出登录 </Col>
       </Row>
     </div>

     <Divider className={userStyles.divider}></Divider>
      <div className={userStyles.userBotm}>
        <div className={userStyles.btmTitle}>当前机构</div>
        <div className={userStyles.institution}>
          <Row justify="space-between" align={'middle'} wrap={false}>
            <Col className={userStyles.collegeNameContain}>
              {collegeName == ''
                ? '无'
                : collegeName}
            </Col>
            
            <Col>
            { 
              isManager == 1 && 
              <Button
                style={{ boxShadow:'none',textShadow:'none'}}
                type='link'
                size='small'
                onClick={()=>{window.open('/college-oam')}}
              >
              管理
              </Button>
            }

              <span
                style={{ cursor: 'pointer' }}
                className={userStyles.btmTitle}
                onClick={handleGoUserCenter.bind(userId)}
              >
                {!collegeName ? '设置>' : '切换>'}
              </span>
            </Col>
          </Row>
        </div>
      </div>


  </div>)
  // console.log(userLogin)
  if (userLogin) {
    return (
    
      <Popover placement="bottomRight" title={""}   content={content} trigger="hover"
      overlayClassName = {userStyles.userPopver}
      overlayStyle={{margin:0}}
      overlayInnerStyle={{marginTop:-10,paddingTop:10,borderRadius:5}}
      >
        <div> 
          <img id="header-user-avatar" src={BACKEND_API_URL + userAvatar} />
          <span style={{marginLeft:5}}>{userName}</span>
        </div>
      </Popover>    
    );
  } else {
    return (
        <div >
           { /* <Button style={{borderRadius:15, width:80, textShadow:'none', boxShadow:'none'}} type="primary" onClick={handleGoLogin}>登录</Button> */}
           <span className={userStyles.loginBtn} onClick={handleGoLogin}> 登 录 </span>
        </div>
    );
  }
}

export default UserInfo

/**
 * 登录
 */
export function handleGoLogin() {
  /*const pathname = window.location.pathname;
  const location = window.location.href;
  const host = window.location.host + "/";
  const search = window.location.search;
  // const jumpUrl = location.split(host)[1];
  const jumpUrl = pathname + search;
  // console.log(window.location);
  // console.log(jumpUrl);
  // return;
  pathname != "/" ? window.location.href = "/login?next=" + jumpUrl : window.location.href = "/login";*/

  sessionStorage.setItem("previousurl",window.location.href )
  document.getElementById('show-login-modal')!.click()

}

export function logoutCallback() {
  delCookie("sessionid" );
  localStorage.removeItem("user_info");
  localStorage.removeItem("college_info");
  try {
    if(localStorage.getItem("already_setting")){
      localStorage.removeItem("already_setting")
    }
  } catch (error) {
    
  }
  window.location.reload();
}

/**
 * 退出登录
 */
export function handleGoLogout() {
  const sessionid_ = getCookie("sessionid");
  try {
    sendHttpPostRequest(
        'account/api/logout/',
        {sessionid: sessionid_},
        logoutCallback
    );
  } catch (e) {
    logoutCallback
  }

}

/**
 * 个人中心
 */
export function handleGoUserCenter() {
  window.location.href = '/user-center';
}

/**
 * 外部调用判断是否登录了
 */
export function checkUserLogin() {
  return globalUserLogin;
}


